import React from 'react';
import { useState, useMemo } from 'react';
import { Link } from "react-router-dom";
import styles from './../../styles/PageTitle.module.css'
import ListTable from '../utils/Table'
import { useLocation } from "react-router-dom";
export default function ProductList() {
  const location = useLocation()

  const [invoice ,setInvoice]  = useState(location?.state?.Invoice)
useMemo(()=>{
  if(location){
    setInvoice(location?.state?.Invoice)
  }
},[location])
const customer = location?.state.cus

  console.log(location,customer?.state,"HIIIPARTH")

  const [tableData, setTableData] = useState({
    tableTitle: "Product List",
    column_sum: {
      name: "final_price",
      title: "Total Sales",
     
  },
    disableDelete: true,
    tableHead: [

      {
        id: 'product_name',
        label: "Produce Name",
        isSpecial:true,
        align:"left"
        // link:"/Customer/CustomerDetail/MoviesWatched",
      },
      // {
      //   id: 'date',
      //   label: 'Date',
      // },
        {
          id:"product_category",
          label:"Category"
        },
      {
        id: 'quantity',
        label: 'Quantity',
      },
      {
        id: 'unit',
        label: 'Units',
      },
      
      {
        id: 'selling_price',
        label: 'Price',
      },
       {
        id:"product_cgst",
        label:"CGST"
      },
     {
        id:"product_sgst",
        label:"SGST"
      },
     {
        id:"product_igst",
        label:"IGST"
      },
      {
        id: 'final_price',
        label: 'Final amount',
      },
      {
        id: 'total',
        label: 'Total',
      },
    ].filter(e => e),
    tableBody: [

    ]
  })
  // const [form, setForm] = useState({})
  const [isEdit, setIsEdit] = useState(false)

  useMemo(() => {
    const temp = tableData
    temp.tableBody = location?.state?.data?.map((state) => ({
      ...state,
      product_name: state?.product?.product_name?.length <= 35 ? state?.product?.product_name : state?.product?.product_name.substring(0, 35) + "...",
      HSN : state?.product?.HSN,
      unit : state?.product?.unit_of_measure?.unit_name,
      product_category : state?.product?.product_category?.category_name,
      selling_price : parseFloat(state?.selling_price).toFixed(2),
      final_price : parseFloat(state?.final_price).toFixed(2),
      product_cgst : customer?.state == "Gujarat" ? parseFloat(state?.product_cgst).toFixed(2) : "-",
      product_sgst : customer?.state == "Gujarat" ? parseFloat(state?.product_sgst).toFixed(2) : "-",
      product_igst : customer?.state != "Gujarat" ? parseFloat(state?.product_igst).toFixed(2) : "-",
      total : parseFloat(state?.selling_price *state?.quantity ).toFixed(2)
      // invoic : location.state.Invoice,
      // date: state?.date <  new Date() ? <p style={{color:"red"}}>{state?.data}</p> :<p style={{color:"blue"}}>{state?.data}</p> 
    }))  || []
    setTableData({ ...temp })
  }, [location.state?.data ,customer])

  useMemo(() => {
    setTableData({ ...tableData });
  }, [customer]);
  return (
    <>



      <ListTable tableData={tableData} key={"ListTable"} setTableData={setTableData} setIsEdit={setIsEdit} />


    </>
  );
}
